import React from 'react';
interface LeadCaptureFormProps {
  onSubmit: (data: {
    firstName: string;
    email: string;
  }) => void;
}
export function LeadCaptureForm({
  onSubmit
}: LeadCaptureFormProps) {
  return <div className="w-full max-w-2xl mx-auto" data-id="element-82">
      <div className="bg-crown-surface border border-crown-border rounded-lg p-6 sm:p-8" data-id="element-83">
        <h2 className="text-2xl md:text-3xl font-bold text-crown-text mb-6" data-id="element-84">
          Where should we send your Hair Retention Score and custom non-hormonal
          protocol?
        </h2>
        <div className="klaviyo-form-XkLzHC" data-id="element-85"></div>
      </div>
    </div>;
}